import React, { useState, useRef } from "react";
// import "./Discount.css";
import Groceryvendorcoupsdetails from "./Groceryvendorcoupsdetails";
import { Link } from "react-router-dom";
import Grocerycoupons from "./Grocerycoupons";
import Grocerytopratedlist from "./Grocerytopratedlist";

const Promotionsgrocery = () => {
    const [activeTab, setActiveTab] = useState("Coupons");
    const [formData1, setFormData1] = useState({
        "offer type": "",
        "Discount Percentage": "",
        "Start Date": "",
        "End Date": "",
        Description: "",
        goal: "",
        status: "Active", // Added status
    });
    const tabContent = {
        "Coupons": <Grocerycoupons />,
        "Vendor List": <Groceryvendorcoupsdetails />,
        "Vendor Rating": <Grocerytopratedlist />,
        // "Main Page": <MainData />,
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10" style={{ height: "80vh", overflowY: "auto", marginTop: "122px", scrollbarWidth: "none" }}>
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "60px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            // zIndex: 1000,
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Promotions_Discounts
                            </Link>
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Fresh & Grocery
                        </span>
                    </p>
                    <div className="discount-container">
                        {/* Responsive, centered tab buttons */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "fixed",
                                top: "120px",
                                left: "55%",
                                transform: "translate(-45%, -50%)",
                                gap: "0px",
                                zIndex: 10,
                                width: "90vw",
                                maxWidth: "600px",
                                flexWrap: "wrap",
                                padding: "10px 0",
                            }}
                            className="rorr row b2"
                        >
                            {Object.keys(tabContent).map((label) => (
                                <div
                                    key={label}
                                    className="col-lg-3 col-md-6 col-sm-12 col-12"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        minWidth: "150px",
                                    }}
                                >
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                        {/* Tab Content - Scrollable Part */}
                        <div
                            style={{
                                height: "95vh",
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                paddingTop: "20px",
                                borderRadius: "8px",
                                marginTop: "0px",
                            }}
                            className="b1"
                        >
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Make sure these are defined as in your original code
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
};
const viewButtonStyle = {
    // This style is now more generic for modal buttons
    border: "none",
    color: "white", // Default color, can be overridden
    cursor: "pointer",
    borderRadius: "5px",
    fontWeight: "bold",
};

const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999, // High z-index
};

const modalContent = {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "450px", // Slightly wider for better form layout
    maxWidth: "90%",
    maxHeight: "90vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};

const closeButtonStyle = {
    backgroundColor: "#6c757d",
    border: "none",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
};
const actionButtonStyle = {
    color: "white",
    padding: "6px 10px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: "5px",
    fontWeight: "bold",
    fontSize: "0.85rem",
};

export default Promotionsgrocery;
